import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-chevron-left',
  styleUrls: ['./chevron-left.component.scss'],
  templateUrl: './chevron-left.component.html'
})
export class ChevronLeftComponent {}
